import axios from "../../utils/axios";

export const getProjects = async ({
  status,
  startDate,
  endDate,
  searchKeyword,
  pageNumber,
  pageSize,
  isArchived,
}) => {
  const res = await axios.get("project/getList", {
    params: {
      status,
      startDate,
      endDate,
      searchKeyword,
      pageNumber,
      pageSize,
      isArchived,
    },
  });

  return res;
};

export const getProjectById = async (id) => {
  const res = await axios.get(`project/${id}`);

  return res;
};

export const deleteProjectById = async (id) => {
  const res = await axios.delete(`project/${id}`);

  return res;
};

export const togglePublishedById = async (id) => {
  const res = await axios.patch(`project/togglePublish/${id}`);

  return res;
};

export const toggleArchivedById = async (id) => {
  const res = await axios.patch(`project/toggleArchived/${id}`);

  return res;
};

export const createProject = async (formData) => {
  const res = await axios.post("project/create", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res;
};

export const updateProjectById = async (id, projectData) => {
  const res = await axios.put(`project/${id}`, projectData);

  return res;
};

export const deleteMediaById = async (mediaId) => {
  const res = await axios.delete(`album/media/${mediaId}`);

  return res;
};
